import React from 'react';
import { FunctionField } from 'react-admin';

import { TextPopover } from '../popovers/IconButtonPopover';

export const TextPopoverField = props => <FunctionField {...props}  render={record => <TextPopover text={record[props.source]} /> } />;